/* eslint-disable */
import React from 'react'
import ReactDOM from 'react-dom'
import slider from 'rangeslider-js'
import platform from '../utils/platform'
import colors from '../utils/colors'
import {
  Text,
  StyleSheet,
  View,
  TouchableWithoutFeedback,
} from 'react-native'

const styles = StyleSheet.create({
  popover: {
    position: 'absolute',
    bottom: 70,
    width: 400,
    backgroundColor: '#000',
    left: '50%',
    marginLeft: -200,
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 30,
    paddingRight: 30,
  },
  
  toggle: {
    color: 'black',
    fontSize: 64,
    textAlign: 'center',
    lineHeight: 35,
    height: 55,
    userSelect: 'none',
    outline: 'none',
  },
  
  caption: {
    marginTop: 20,
    paddingTop: 10,
    paddingBottom: 10,
    fontWeight: '600',
    fontSize: 12,
    color: 'white',
  },
  
  group: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: 'white',
    marginTop: 10,
  },
  
  groupItem: {
    flex: 1,
    textAlign: 'center',
    fontWeight: '500',
    paddingTop: 10,
    paddingBottom: 10,
    userSelect: 'none',
    color: 'white',
  },
  
  groupItemActive: {
    backgroundColor: 'white',
    color: 'black',
  },
  
  popoverTriangle: {
    position: 'absolute',
    left: '50%',
    bottom: -34,
    marginLeft: -17,
    borderWidth: 17,
    borderTopColor: '#000',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: 'transparent',
  },
})

export default class OptionsPanel extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
      showPopover: false,
    }
  }
  
  componentDidMount() {
    const sliderContainer = ReactDOM.findDOMNode(this.sliderContainerRef)
    
    sliderContainer.innerHTML = '<input id="slider" type="range"></input>'
    slider.create(document.getElementById('slider'), {
      value: this.props.sliderValue * 100,
      onSlideEnd: (value) => {
        this.props.onChangeSlider(value / 100)
      }
    })
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.sliderValue != this.props.sliderValue) {
      document.getElementById('slider')['rangeslider-js'].update({
        value: this.props.sliderValue * 100
      })
    }
  }
  
  toggle() {
    this.setState({
      showPopover: !this.state.showPopover
    })
  }
  
  onPressValue(type) {
    switch(type) {
      case 'advanced-mode-enabled':
        this.props.emit('enableAdvancedMode')
      break
      
      case 'advanced-mode-disabled':
        this.props.emit('disableAdvancedMode')
      break
      
      case 'night-mode-enabled':
        this.props.emit('enableNightMode')
      break
      
      case 'night-mode-disabled':
        this.props.emit('disableNightMode')
      break
    }
  }
  
  render() {
    const C = colors(this.props.settings.nightModeEnabled)
    
    return (
      <View style={this.props.style}>
        <Text style={[styles.toggle, C.color]} onPress={this.toggle.bind(this)}>···</Text>
        
        <View style={[styles.popover, C.backgroundColor, {display: this.state.showPopover ? 'flex' : 'none'}]}>
          <View style={[styles.popoverTriangle, C.borderTopColor]} pointerEvents='none'></View>
          <View ref={ref => this.sliderContainerRef = ref}></View>
          
          <View style={styles.selectionContainer}>
            <Text style={[styles.caption, C.colorInverted]}>ADVANCED MODE</Text>
            
            <View style={[styles.group, C.borderColorInverted]}>
              <Text style={[styles.groupItem, C.colorInverted, C.backgroundColor, ...(this.props.settings.advancedModeEnabled ? [styles.groupItemActive, C.color, C.backgroundColorInverted] : [])]}
                    onPress={this.onPressValue.bind(this, 'advanced-mode-enabled')}>
                ENABLED
              </Text>
              
              <Text style={[styles.groupItem, C.colorInverted, C.backgroundColor, ...(!this.props.settings.advancedModeEnabled ? [styles.groupItemActive, C.color, C.backgroundColorInverted] : [])]}
                    onPress={this.onPressValue.bind(this, 'advanced-mode-disabled')}>
                DISABLED
              </Text>
            </View>
          </View>
          
          <View style={styles.selectionContainer}>
            <Text style={[styles.caption, C.colorInverted]}>NIGHT MODE</Text>
            
            <View style={[styles.group, C.borderColorInverted]}>
              <Text style={[styles.groupItem, C.colorInverted, C.backgroundColor, ...(this.props.settings.nightModeEnabled ? [styles.groupItemActive, C.color, C.backgroundColorInverted] : [])]}
                    onPress={this.onPressValue.bind(this, 'night-mode-enabled')}>
                ENABLED
              </Text>
              
              <Text style={[styles.groupItem, C.colorInverted, C.backgroundColor, ...(!this.props.settings.nightModeEnabled ? [styles.groupItemActive, C.color, C.backgroundColorInverted] : [])]}
                    onPress={this.onPressValue.bind(this, 'night-mode-disabled')}>
                DISABLED
              </Text>
            </View>
          </View>
        </View>
      </View>
    )
  }
}
